module.exports = __webpack_public_path__ + "static/media/ic_nofire.0ba12a4f.png";